module.exports = __webpack_public_path__ + "media/images/bg/about-us-31948cd2983e2769fb191f019a8934ce.svg";